import React from 'react'
import CustomTextField from './mui/text-field'
import AutocompleteMui from './mui/autocomplete'

export default function CustomAutocomplete({
  disableClearable = false,
  options,
  onChange,
  value,
  label = '',
  freeSolo = false,
  placeholder,
  onInputChange,
  disabled
}) {
  return (
    <AutocompleteMui
      disableClearable={disableClearable}
      sx={{
        width: '100%'
      }}
      disabled={disabled}
      freeSolo={freeSolo}
      options={options}
      value={value}
      onChange={(event, value) => {
        onChange(value)
        // setValue('customAutocomplete', value)
      }}
      getOptionLabel={(option) => option.label || ''}
      isOptionEqualToValue={(option, value) => option.label === value.label}
      renderInput={(params) => (
        <CustomTextField
          {...params}
          value=""
          label={label}
          onChange={(e) => {
            freeSolo
              ? onChange({ label: e.target.value, value: e.target.value })
              : onInputChange(e.target.value)
          }}
          placeholder={placeholder}
        />
      )}
    />
  )
}
